import { ReactNode } from 'react';

import { useEnv } from '../../../utils/hooks';
import { NotFoundPage } from '../../ErrorPage';

interface RequireAdminProps {
  children: ReactNode;
}

export const RequireAdmin = ({ children }: RequireAdminProps) => {
  const env = useEnv();
  const isAdmin = env?.menu?.user?.isAdmin;

  if (!isAdmin) return <NotFoundPage />;

  return <>{children}</>;
};
